// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["resources/assets/styles/bundle"], () => (__webpack_require__("./resources/source/vue.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["resources/assets/styles/bundle"], () => (__webpack_require__("./resources/source/sass/bundle.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
